export default "__VITE_ASSET__CpeHmCDE__"